module.exports = __webpack_public_path__ + "img/ti5.20265285.jpg";